import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

class GenericModal extends Component {
    render() {
        const {
            isOpen,
            title = 'Aviso',
            description,
            hasConfirm = true,
            confirmText = 'Confirmar',
            cancelText = 'Fechar',
            onConfirm,
            onClose,
            isDelete = false,
        } = this.props

        return (
            <Modal
                isOpen={isOpen}
                toggle={onClose}
                backdrop={true}
                keyboard={true}
            >
                <ModalHeader toggle={onClose}>
                    <div>
                        <i className="fa fa-exclamation fa-20px" />
                        {title}
                    </div>

                </ModalHeader>

                <ModalBody>
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                </ModalBody>

                <ModalFooter>
                    <button
                        className="hdv-btn-forms hdv-btn-default"
                        onClick={onClose}
                    >
                        {hasConfirm ? cancelText : 'Fechar'}
                    </button>

                    {hasConfirm && (
                        <button
                            className={`hdv-btn-forms ${isDelete ? 'hdv-btn-red' : 'hdv-btn-blue'}`}
                            onClick={onConfirm}
                        >
                            {confirmText}
                        </button>
                    )}
                </ModalFooter>
            </Modal>
        )
    }
}

export default GenericModal
